export default __webpack_public_path__ + "static/logo-2024-0d1eaf304be20e8dd358e9e2328af9d0.svg";